import _createForOfIteratorHelper from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _objectSpread from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/graphistry/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
//Written with intent for moving to JS client

import axios from 'axios';
import { baseFormats, compressFormats, compressFormatToFileCompression, fileCompressionToCompressFormat } from './formats';
import logger from '../utils/logger';
var log = logger.createLogger('GraphistryWebFileUploader');
export var AGENT_NAME = 'graphistry-file-uploader';
export var AGENT_VERSION = typeof __BUILDNUMBER__ !== 'undefined' ? "".concat(__BUILDNUMBER__) : '1.0.0';

//Clientside within Graphistry (not node)
//Handles X-CSRFToken header
//Chainable with createFile info passed for uploadFileData via this._data
export var GraphistryWebFileUploader = /*#__PURE__*/function () {
  function GraphistryWebFileUploader() {
    _classCallCheck(this, GraphistryWebFileUploader);
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var session = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {/*csrfToken: str, activeOrganization: ?str*/};
    var authMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'csrf';
    var axiosOverride = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var basePath = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    log.debug({
      opts: opts,
      session: session
    }, '@GraphistryWebFileUploader');
    this.opts = _objectSpread({
      'agent_name': AGENT_NAME,
      'agent_version': AGENT_VERSION
    }, opts);
    this._session = session;
    this._data = null;
    this._authMode = authMode;
    this._basePath = basePath;
    this._axios = axiosOverride || axios;
  }
  return _createClass(GraphistryWebFileUploader, [{
    key: "headers",
    value: function headers() {
      var headers = {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRFToken': this.resolveCsrfToken(),
        'Content-Type': 'application/json'
      };
      return headers;
    }

    //Ex: {"name": "abc.csv.gz"} -> "gzip"
  }, {
    key: "resolveFileCompression",
    value: function resolveFileCompression() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      log.debug({
        opts: opts
      }, '@resolveFileCompression');
      if ('file_compression' in opts) {
        log.debug('////resolveFileCompression provided: %s', opts['file_compression']);
        return opts['file_compression'];
      }
      if (opts['name']) {
        var name = opts['name'].toLowerCase();
        log.debug("checking name [ ".concat(name, " ]"));
        var _iterator = _createForOfIteratorHelper(compressFormats),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var sfx = _step.value;
            if (name.endsWith(sfx)) {
              log.debug({
                theName: name,
                sfx: sfx
              }, 'compression match, truncating');
              name = name.slice(0, -sfx.length);
              var out = compressFormatToFileCompression[sfx];
              log.debug({
                out: out
              }, '////resolveFileCompression');
              return out;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      throw new Error("Could not match file compression suffix [".concat(opts.name, "] to known compression type"));
    }

    //Ex: {"name": "abc.csv.tar.gz"} -> "csv"
  }, {
    key: "resolveFileType",
    value: function resolveFileType() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      log.debug({
        opts: opts
      }, '@resolveFileType');
      if ('file_type' in opts) {
        log.debug({
          'file_type': opts['file_type']
        }, '////resolveFileType provided');
        return opts['file_type'];
      }
      if (opts['name']) {
        var name = opts['name'].toLowerCase();
        try {
          var compressionType = this.resolveFileCompression(opts);
          var compressionSuffix = fileCompressionToCompressFormat[compressionType];
          var filePrefix = name.slice(0, -compressionSuffix.length);
          log.debug("removing compression from name [ ".concat(name, " :: ").concat(compressionType, " ] -> [ ").concat(filePrefix, " ]"));
          name = filePrefix;
        } catch (e) {
          log.debug({
            e: e
          }, 'No known file compression suffix; assume uncompressed');
        }
        var _iterator2 = _createForOfIteratorHelper(baseFormats),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var ext = _step2.value;
            if (name.endsWith(ext)) {
              log.debug({
                name: name,
                ext: ext
              }, '////resolveFileType ext match, returning without dot');
              return ext.slice(1);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      throw new Error("Could not match file name [".concat(opts.name, "] to known extension and optional compression type"));
    }

    //?dict => Promise dict
    //set this._data with file container upon success
    // Helper to get CSRF token from cookie (more reliable than template value)
  }, {
    key: "getCsrfTokenFromCookie",
    value: function getCsrfTokenFromCookie() {
      var name = 'csrftoken';
      var cookies = document.cookie.split(';');
      var _iterator3 = _createForOfIteratorHelper(cookies),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var cookie = _step3.value;
          cookie = cookie.trim();
          if (cookie.startsWith(name + '=')) {
            return cookie.substring(name.length + 1);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return null;
    }

    // Single source of truth for CSRF resolution: try the cookie first, then the
    // session value, then the DOM input. Both createFile and uploadFileData must
    // use this so the two requests never disagree (for example the cookie succeeds
    // on create but the session token is empty on upload).
  }, {
    key: "resolveCsrfToken",
    value: function resolveCsrfToken() {
      var csrfToken = this.getCsrfTokenFromCookie();
      if (!csrfToken) {
        csrfToken = this._session.csrfmiddlewaretoken;
      }
      if (!csrfToken) {
        var tokenInput = document.querySelector('[name=csrfmiddlewaretoken]');
        csrfToken = tokenInput ? tokenInput.value : '';
      }
      return csrfToken;
    }
  }, {
    key: "createFile",
    value: function createFile() {
      var _this = this;
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      log.debug({
        opts: opts,
        selfOpts: this.opts,
        session: this._session
      }, 'createFile');

      // CSRF token for auth
      var csrfToken = this.resolveCsrfToken();
      var fileCompressionObj = {
        'compression': ''
      };
      try {
        var fileCompression = this.resolveFileCompression(opts);
        fileCompressionObj['compression'] = fileCompression;
      } catch (e) {
        //not compressed
      }
      var preCombinedOpts = _objectSpread(_objectSpread({}, this.opts), opts);
      var combinedOpts = _objectSpread(_objectSpread(_objectSpread({}, preCombinedOpts), this._session.activeOrganization ? {
        'org_name': this._session.activeOrganization
      } : {}), {}, {
        parser_options: _objectSpread(_objectSpread({}, fileCompressionObj), (preCombinedOpts || {}).parser_option || {}),
        file_type: this.resolveFileType(preCombinedOpts)
      });
      var url = "".concat(this._basePath, "/api/v1/files/");
      var headers = {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRFToken': csrfToken
      };

      // Use fetch() instead of XMLHttpRequest to avoid potential XHR interceptors
      return fetch(url, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: headers,
        body: JSON.stringify(combinedOpts)
      }).then(function (resp) {
        if (resp.status === 201) {
          return resp.json().then(function (data) {
            _this._data = data;
            return data;
          });
        } else {
          return resp.json().then(function (errData) {
            var msg = JSON.stringify(errData);
            log.error({
              responseData: msg
            }, 'Create fail');
            throw new Error('Error (code ' + resp.status + '): Failed creating file container:\n ' + msg);
          }).catch(function (e) {
            if (e.message && e.message.startsWith('Error (code')) throw e;
            throw new Error('Error (code ' + resp.status + '): Failed creating file container');
          });
        }
      }).catch(function (e) {
        if (e.message && e.message.startsWith('Error (code')) throw e;
        throw new Error('Network error occurred: ' + e.message);
      });
    }
  }, {
    key: "uploadFileData",
    value: function uploadFileData(data) {
      var _this2 = this;
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      log.debug({
        data: data,
        opts: opts
      }, '@uploadFileData');
      var erase = opts.erase,
        fileID = opts.fileID,
        progress = opts.progress;
      var eraseParam = erase === undefined ? true : erase;
      var url = "".concat(this._basePath, "/api/v2/upload/files/").concat(fileID || this._data.file_id);
      var headers = {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRFToken': this.resolveCsrfToken()
      };

      // Use axios (XMLHttpRequest) rather than fetch so onUploadProgress fires during the
      // upload and drives the progress bar. fetch exposes no request upload progress event,
      // which is why the ported bar was dead. The nexus page loads Pace.js, which wraps
      // XMLHttpRequest, but Pace only tracks GET and never touches xhr.upload, so it does
      // not interfere with this POST or with progress.
      var axiosCfg = _objectSpread(_objectSpread({
        method: 'POST',
        url: url,
        params: {
          erase: eraseParam
        },
        headers: headers,
        withCredentials: true,
        data: data
      }, progress ? {
        onUploadProgress: progress
      } : {}), {}, {
        validateStatus: function validateStatus(status) {
          return status === 200;
        }
      });
      log.debug({
        url: url
      }, 'uploadFileData cfg');
      return this._axios(axiosCfg).then(function (resp) {
        _this2._data = resp.data;
        log.debug({
          respData: resp.data
        }, 'axios resp.data');
        return resp.data;
      }).catch(function (e) {
        var err;
        log.error({
          eData: e && e.response && e.response.data || e && e.response || e
        }, 'Failed file transfer');
        try {
          var respData = e.response.data;
          err = respData.message;
        } catch (e2) {}
        if (!err) {
          err = (e || '').toString();
        }
        throw new Error("Failed file transfer:\n ".concat(err));
      });
    }
  }]);
}();